<template>
  <div class="app-container">
    <iframe
      id="appiframe"
      ref="appIframe"
      :src="iframeSrc"
      frameborder="0"
      allowfullscreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    ></iframe>
  </div>
</template>
<script>
import moment from 'moment';
import { mapMutations } from 'vuex'
import { getData } from './const';
import Service from '../../../env/index.js';
import {getReplenishmentCustomer} from './api'

export default {
  data() {
    return {
      openAppData: {},
      iframeSrc: `${Service.IFRAME_ORIGIN}/#/appcenter`,
      IFRAME_DATA: {}
    };
  },
  computed: {
    getCount() {
      return this.$store.state.setting.count || 0
    }
  },
   created() {
    window.addEventListener('message', this.resiveIframeMessage);
  },
  mounted() {
    this.$refs.appIframe.onload = () => {
      const token = this.$store.state?.user?.token || ''
      const user = JSON.parse(localStorage.getItem('vuex') || '{}')?.user || {}
      
      const {customers,creditCode} = this.$store.state.user
      if(!creditCode){
        this.IFRAME_DATA = getData(user, token)
      }else{
         this.IFRAME_DATA = getData(user, token,customers)
      }
      this.sendMessageToIframe();
    };
  },
  beforeDestroy() {
    window.removeEventListener('message', this.resiveIframeMessage)
  },
  methods: {
      ...mapMutations('user', ['SET_USER_DATA']),
      ...mapMutations('setting', ['setCount']),
   async resiveIframeMessage(e) {
      let { data } = e;
      if (data) {
        if (typeof data === 'string') {
          data = JSON.parse(data);
        }
        if (data.type === 'application') {
          this.openApp(data);
        }
        if(data.type==='changeSelect'){
          this.saveCarrier(data.data)
           const {token,customers} = this.$store.state.user
           this.IFRAME_DATA = getData(this.$store.state.user, token,customers)
          const res= await getReplenishmentCustomer({})
          this.setCount(res.length)
          this.sendMessageToIframe('upNum')
        }
      }
    },
    saveCarrier(data){
       const {carrierTenantId,carrierTenantName,id,customerCode,customerName}=data
         const selectCarriering={
            tenantId:carrierTenantId,
            tenantName:carrierTenantName,
            customerId:id,
            customerCode,
            customerName,
         }
         Object.keys(selectCarriering).forEach(item=>{
            this.SET_USER_DATA([item,selectCarriering[item]])
         })
    },
    openApp(data) {
      const { app } = data;
      this.openAppData = app;
      this.beforeOpenApp();
    },
    beforeOpenApp() {
      // const { type, appId, number, iframeUrl, needAccess } = this.openAppData
      // // 如果是内部链接
      // if (type === 'own') {
      //   // 是智能补货需要有个数才能跳转
      //   if (appId === 'intelligentReplenishment' && !number) {
      //     this.$message.warning('没有需要补货的货主')
      //     return
      //   } 
      //   this.$router.push({
      //     path: this.openAppData.path,
      //   });
      // } else if (needAccess && !this.bigWhite) {
      //   this.$message.warning('暂无权限，请联系平台开通')
      // } else {
      //   this.$router.push({
      //     path: this.openAppData.path,
      //     query: {
      //       iframeUrl
      //     }
      //   })
      // }
    },
    openAppByintelligentCable() {
      const likeYesterdayParams = {
        queryType: 'ROUTE_PLAN_DP',
        queryStartTime: moment().startOf('day'),
        queryEndTime: moment().endOf('day'),
      };
      sessionStorage.setItem('likeYesterdayParams', JSON.stringify(likeYesterdayParams));
    },
    openOtherPage() {},
    sendMessageToIframe(type) {
      // this.IFRAME_DATA.apps.map(app => {
      //   const item  = app
      //   if (item.appId === 'intelligentReplenishment') {
      //     item.number = this.$store.state.setting.count
      //   }
      //   return item
      // })
      if(this.$store.state.user.creditCode&&type){
        this.IFRAME_DATA.upNumber='upNumber'
      }
      const data = JSON.stringify(this.IFRAME_DATA);
      document.getElementById('appiframe').contentWindow.postMessage(data,Service.IFRAME_ORIGIN);
    },
  },
};
</script>
<style lang="less" scoped>
#appiframe {
  width: 100%;
  height: 100%;
  display: block;
}
.app-container {
  padding: 0 24px;
  height: calc(100vh - 40px); // 王谦要求
}
</style>
